enum ActionTypes {
  GET_SECRET_CODES = '@user/GET_SECRET_CODES',
  VALIDATE_CODES = '@user/VALIDATE_CODES',
  DISABLE_CODES = '@user/DISABLE_CODES',
  CREATE_BACKUP_CODES = '@user/CREATE_BACKUP_CODES',
  GET_BACKUP_CODES = '@user/GET_BACKUP_CODES',
  GET_ALL_USERS = '@user/GET_ALL_USERS',
  CREATE_USER = '@user/CREATE_USER',
  UPDATE_USER = '@user/UPDATE_USER',
  DELETE_USER = '@user/DELETE_USER',
}

export default ActionTypes
